import { Suspense } from 'react';

import { Outlet } from 'react-router-dom';

import { cn } from '@/lib/utils/cn';
import { useSettingsStore } from '@/store';
import MaintenanceBanner from '../shared/maintenance/MaintenanceBanner';
import { Footer } from '../template/Footer';
import { Navbar } from '../template/navbar/Navbar';
import PageLoader from '../template/PageLoader';

const UserLayout = () => {
  const { settings } = useSettingsStore();

  const showMaintenanceBanner =
    settings.ui?.maintenance?.type === 'banner' &&
    settings.ui?.maintenance?.enabled;

  return (
    <div className="flex flex-col flex-auto min-h-screen min-w-0 relative w-full">
      <Navbar />
      {showMaintenanceBanner && <MaintenanceBanner />}
      <div
        className={cn(
          'h-full flex flex-auto flex-col justify-between',
          !showMaintenanceBanner && 'mt-16'
        )}
      >
        <Suspense fallback={<PageLoader />}>
          <main className="relative h-full flex flex-auto flex-col p-2 sm:px-6 md:px-8 sm:py-6 container">
            <Outlet />
          </main>
        </Suspense>
        <Footer />
      </div>
    </div>
  );
};

export default UserLayout;
